import React, {useEffect} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Card,
  Grid,
  TextField,
  Button
} from '@material-ui/core';
import { BackdropCircular, Breadcrumb } from 'components';
import { Formik } from 'formik';
import * as yup from 'yup';
import { getSocialMediaConfigsApi, updateStoreConfigsApi } from 'api';
import { changeSocialMediaConfig } from 'redux/actions/store_configs';


const Socials = () => {
  const dispatch = useDispatch();
  const urlRegExp = /^(https?:\/\/)?([\w.-]+\.[a-z]{2,})/;

  const {storeSocialMediaConfigs, loadingStoreSocialMediaConfigs} = useSelector((state) => state.store_configs);

  useEffect(() => {
    if (storeSocialMediaConfigs.length === 0) {
      getSocialMediaConfigsApi({dispatch});
    }
  }, []);

  const handleChangeSocialUrl = (name, value) => {
    dispatch(changeSocialMediaConfig(name, value));
  };

  const handleSaveSocialMediaConfigs = () => {
    const configs = storeSocialMediaConfigs.filter((config) => config.value !== null);
    updateStoreConfigsApi({dispatch, configs});
  };


  return (
    <div className="flex-grow flex-column relative h-full scroll-y">
      <div>
        <Breadcrumb
          routeSegments={[
            { name: 'Settings', path: '/settings#go_live_requirements' },
            { name: 'UI Configurations', path: '/settings#UI_configurations' },
            { name: 'Social Media Links' }
          ]}
        />
      </div>
      <div className="mt-10 mx-10">
        <Formik
          onSubmit={() => handleSaveSocialMediaConfigs()}
          initialValues={{}}
          validationSchema={
            yup.object({
              facebook_url: yup
                .string()
                .matches(urlRegExp, 'Please enter a valid URL address.'),
              youtube_url: yup
                .string()
                .matches(urlRegExp, 'Please enter a valid URL address.'),
              pinterest_url: yup
                .string()
                .matches(urlRegExp, 'Please enter a valid URL address.'),
              linkedin_url: yup
                .string()
                .matches(urlRegExp, 'Please enter a valid URL address.'),
              instagram_url: yup
                .string()
                .matches(urlRegExp, 'Please enter a valid URL address.'),
              yelp_url: yup
                .string()
                .matches(urlRegExp, 'Please enter a valid URL address.'),
              blog_url: yup
                .string()
                .matches(urlRegExp, 'Please enter a valid URL address.'),
              twitter_url: yup
                .string()
                .matches(urlRegExp, 'Please enter a valid URL address.'),
              realself_url: yup
                .string()
                .matches(urlRegExp, 'Please enter a valid URL address.'),
              rss_url: yup
                .string()
                .matches(urlRegExp, 'Please enter a valid URL address.'),
              snapchat_url: yup
                .string()
                .matches(urlRegExp, 'Please enter a valid URL address.'),
              tiktok_url: yup
                .string()
                .matches(urlRegExp, 'Please enter a valid URL address.'),
            })
          }
        >
          {({
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit
          }) => (
            <>
              <form autoComplete="off" onSubmit={handleSubmit}>
                <p className="text-muted">In this section you can add Social Media Links to your store. To remove link from store just leave empty field.</p>
                <Card className="p-8">
                  {storeSocialMediaConfigs?.map((config) => {
                    let [socialMediaName] = config.path?.split('/')[config.path?.split('/').length - 1].split('_') || [];
                    const socialName = config.path?.split('/')[config.path?.split('/').length - 1];
                    socialMediaName === 'linkedin' ? socialMediaName = 'LinkedIn' : null;
                    socialMediaName === 'realself' ? socialMediaName = 'RealSelf' : null;
                    socialMediaName === 'rss' ? socialMediaName = 'RSS' : null;
                    socialMediaName === 'youtube' ? socialMediaName = 'YouTube' : null;
                    socialMediaName === 'tiktok' ? socialMediaName = 'TikTok' : null;
                    socialMediaName === 'twitter' ? socialMediaName = 'X' : null;

                    return (
                      <Grid key={config.path} spacing={5} container className="flex items-center">
                        <Grid item xs={12} sm={3} md={2} className="capitalize">
                          {socialMediaName}
                        </Grid>
                        <Grid item xs={12} sm={9} md={10}>
                          <TextField
                            fullWidth
                            className="max-w-600"
                            variant="outlined"
                            name={socialName}
                            value={config.value}
                            label="Social URL"
                            onChange={(event) => {
                              handleChange(event);
                              handleChangeSocialUrl(config.path, event.target.value, errors);
                            }}
                            onBlur={(event) => {
                              handleBlur(event);
                            }}
                            error={touched[socialName] && Boolean(errors[socialName])}
                            helperText={touched[socialName] && errors[socialName]}
                          />
                        </Grid>
                      </Grid>
                    );
                  })}
                </Card>
                <div className="flex justify-end">
                  <Button type="submit" variant="contained" color="primary" className="my-10">Save Configurations</Button>
                </div>
              </form>
            </>
          )}
        </Formik>
        <div className="flex justify-end">
          <BackdropCircular loading={loadingStoreSocialMediaConfigs} />
        </div>
      </div>
    </div>
  );
};

export default Socials;
